module.exports = __webpack_public_path__ + "img/9ccc30c.png";